import { Async } from 'react-select';
import createSelect from './createSelect';

export default createSelect(Async);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/select/dist/esm/AsyncSelect.js
// module id = 1273
// module chunks = 0